<template>
  <div :id="tabID" @contextmenu.prevent="tabCtxMenu">
    <ssh-user-input :tabID="tabID" :sessAndPath="sessAndPath" :session="session" ref="sui" />
    <ssh-password-input :tabID="tabID" :sessAndPath="sessAndPath" :session="session" ref="spi" />
    <ssh-private-key-passphrase-input :tabID="tabID" :sessAndPath="sessAndPath" :session="session" ref="ppi" />
    <ssh-verify-server-keys :tabID="tabID" :session="session" ref="vsk" />

    <context-menu id="tab-context-menu" ref="tabCtxMenu" class="ctx-menu">
      <ctx-menu-item @click="term.selectAll()">全选</ctx-menu-item>
      <ctx-menu-item @click="termCopySelection" :hot-key="utils.runtime.isDarwin() ? utils.hotKey.getTextByName('copy') : 'Ctrl+Insert'">复制</ctx-menu-item>
      <ctx-menu-item @click="pasteHandler" :hot-key="utils.runtime.isDarwin() ? utils.hotKey.getTextByName('paste') : 'Shift+Insert'">粘贴</ctx-menu-item>
      <ctx-menu-item :isDivider="true" />
      <ctx-menu-item hotKey="Ctrl+Alt+F" @click="openSearch">搜索</ctx-menu-item>
      <ctx-menu-item hotKey="Ctrl+L" @click="clearHandler">清屏</ctx-menu-item>
      <ctx-menu-item :isDivider="true" />
      <ctx-menu-item @click="exportLogHandler">导出日志</ctx-menu-item>
      <ctx-menu-item @click="printLogHandler">打印日志</ctx-menu-item>
      <ctx-menu-item :isDivider="true" />
      <!-- <ctx-menu-item @click="showSessOptionHandler">会话选项</ctx-menu-item> -->
      <ctx-menu-item hotKey="Ctrl+Alt+V" @click="openVimMode">VIM 模式</ctx-menu-item>
      <ctx-menu-item @click="fullscreenHandler" :hot-key="utils.hotKey.getTextByName('toggleSessFullscreen')">全屏显示</ctx-menu-item>
    </context-menu>

    <terminalSearch ref="search" :modalID="'term-search-modal-' + tabID" 
    @closed="focusTermHandler" @search="searchHandler" />

    <vim-mode :tabID="tabID" :data="vimModeData" ref="vimMode" @closed="focusTermHandler" />
  </div>
</template>

<script>
import session from "../session.js"
import sshUserInput from "./sshUserInput"
import sshPasswordInput from "./sshPasswordInput"
import 'xterm/css/xterm.css'
import { Terminal } from 'xterm'
import * as XtermWebfont from 'xterm-webfont'
import { WebglAddon } from 'xterm-addon-webgl'
import { WebLinksAddon } from 'xterm-addon-web-links'
import { SearchAddon } from 'xterm-addon-search'
import {FitAddon} from "xterm-addon-fit";
import SshPrivateKeyPassphraseInput from "./sshPrivateKeyPassphraseInput";
import SshVerifyServerKeys from "./sshVerifyServerKeys";
import {xtermjs as xtermjsUtils} from "../../../utils"
import contextMenu from 'vue-context-menu'
import ctxMenuItem from '../../common/ctxMenuItem.vue'
import terminalSearch from './terminalSearch.vue'
import vimMode from './vimMode.vue'

// let xtermTheme = {
//   foreground: "#fff",
//   background: "#1e1e1e",
//   blue: "#68cdfe",
//   red: "#d15e43",
// }

let xtermThemeDefault = {
  foreground: "#fff",
  background: "#1e1e1e",
  black: '#1c0d1a',
  red: "#ff8585",
  green: '#26f7a7',
  yellow: '#fedd9f',
  blue: "#74e0ff",
  magenta: '#e38efc',
  cyan: '#61f2d4',
}

// http://zhongguose.com
// let xtermThemeChina = {
//   foreground: "#fff",
//   background: "#1e1e1e",
//   black: '#1c0d1a', // 深牵牛紫
//   red: "#f07c82", // 香叶红
//   green: '#5dbe8a', // 蔻梢绿
//   yellow: '#f8df72', // 茉莉黄
//   blue: "#51c4d3",  // 瀑布蓝
//   magenta: '#c08eaf', // (紫色字) 罗兰紫
//   cyan: '#93d5dc', // 海天蓝
// }

let xtermOption = {
    fontSize: 14,
    // fontFamily: "JetBrains Mono Extra Light",  // selected
    fontFamily: "JetBrains Mono Thin",
    // fontFamily: "Iosevka Term Web Light", // selected Iosevka
    // fontFamily: "DejaVu Sans Mono",
    // fontFamily: "Source Han Sans Half Width",
    drawBoldTextInBrightColors: false,
    rendererType: "canvas",
    theme: xtermThemeDefault,
}

export default {
    name: "terminal",
    props: {
        tabID: String,
        sessAndPath: Object,
        shellCmd: String,
        tab: Object,
    },
    components: {
      SshVerifyServerKeys,
      SshPrivateKeyPassphraseInput,
      sshUserInput,
      sshPasswordInput,
      contextMenu,
      ctxMenuItem,
      terminalSearch,
      vimMode,
    },
    data() {
        return {
            session: undefined,
            term: undefined,
            termTitle: "",
            vimModeData: "",
        }
    },
    mounted() {
        this.env.sub('sessionReconnect-' + this.tabID, this.reconnect)
        this.initSession()
    },
    beforeDestroy() {
        this.session.Close()
    },
    methods: {
        initSession() {
            let confPath = this.sessAndPath && this.sessAndPath.path ? this.sessAndPath.path : ""
            this.session = new session.Session(this.tabID, confPath, this.shellCmd)
            this.session.Open(this,
                              this.ctrlPlaneOnOpen, this.ctrlPlaneOnClose, this.ctrlPlaneOnError, this.ctrlPlaneOnMessage,
                              this.dataPlaneOnOpen, this.dataPlaneOnClose, this.dataPlaneOnError, this.dataPlaneOnMessage)
        },
        ctrlPlaneOnOpen() {},
        ctrlPlaneOnClose() {
            // this.disconnectPrint("ctrl", "close")
          console.log(`${this.tabID} ctrl plane close`)
        },
        ctrlPlaneOnError() {
            // this.disconnectPrint("ctrl", "error")
          console.log(`${this.tabID} ctrl plane error`)
        },
        ctrlPlaneOnMessage(ev, ctrlMsg) {
            // console.log("xterm ctrlPlaneOnMessage: ev:", ev)
            // console.log("xterm ctrlPlaneOnMessage: ctrlMsg:", ctrlMsg)
            if (ctrlMsg.Cmd) {
                switch (ctrlMsg.Cmd.Name) {
                    case "readSshLoginUser":
                        this.$refs.sui.show(ctrlMsg)
                        break
                    case "readSshLoginPasswd":
                        this.$refs.spi.show(ctrlMsg)
                        break
                    case "readPassphraseForPrivateKey":
                        this.$refs.ppi.show(ctrlMsg)
                        break
                    case "verifyServerKeys":
                        console.log("verifyServerKeys")
                        this.$refs.vsk.show(ctrlMsg)
                        break;
                    case "terminalUpdateShellCmd":
                        this.$emit("terminalUpdateShellCmd", this.tabID, ctrlMsg.Cmd.Arg)
                        break;
                    default:
                        console.log("unsupport cmd name:", ctrlMsg.Cmd.Name)
                        console.log("ctrlPlaneOnMessage skip ev::", ev)
                }
            }
        },

        dataPlaneOnOpen() {
            // dispose terminal before init terminal for reconnect
            if (this.term !== undefined) {
                this.term.dispose()
            }
            // console.log("dataPlaneOnOpen")
            this.initTerm()
        },
        dataPlaneOnClose(ev) {
            this.disconnectPrint("data", "close", ev)
        },
        dataPlaneOnError(ev) {
            this.disconnectPrint("data", "error", ev)
        },
        dataPlaneOnMessage(ev) {
            // 有未读内容，更新指示器为蓝色
            if (this.env.tab.curTabKey !== this.tabID && this.tab.badge !== "blue") {
                this.updateStatus("unread")
            }

            if (this.tab.sessStatus === "connecting" || this.tab.sessStatus === "close") {
                this.tab.sessStatus = "open"
                this.updateStatus("open")
            }
            
            this.term.write(this.utils.highlight.terminalHighlight(ev.data))
            // this.term.write(ev.data)
        },
        // plane: ctrl/data plane
        // event: close/error
        disconnectPrint(plane, event, ev) {
            this.updateStatus(event)
            this.term.writeln("")
            this.term.writeln("")
            this.term.writeln("")
            console.log(`${plane} plane ${event}: `, ev)
            
            this.term.writeln(`---------------------- Session ${event} (${plane} plane) ----------------------`)
            this.term.writeln(`- Press <${this.chalk.red("Enter")}> to ${this.chalk.red("exit")} tab`)
            this.term.writeln(`- Press <${this.chalk.green("R")}> to ${this.chalk.green("restart")} session`)
            this.term.writeln(`- Press <${this.chalk.blue("S")}> to ${this.chalk.blue("save")} terminal output to file`)
        },
        initTerm() {
            let self = this
            let term = new Terminal(xtermOption)
            term.onData(self.termOnData)
            term.onResize((ev) => {
                // console.log("initTerm on resize: ev:", ev)
                this.session.Resize(ev.cols, ev.rows)
                })
            term.onTitleChange(self.termOnTitleChange)
            term.onSelectionChange(self.termOnSelectionChange)


            let searchAddon = new SearchAddon()
            term.loadAddon(new XtermWebfont())
            self.utils.conf.GlobalConf.termEnableLink ? term.loadAddon(new WebLinksAddon()) : console.log("skip loading web link addon cause by self.utils.conf.GlobalConf:", self.utils.conf.GlobalConf)
            term.loadAddon(searchAddon)
            // console.log(`open terminal in ${self.tabID} div`)
            let el = document.getElementById(self.tabID)
            term.loadWebfontAndOpen(el).then(() => {
                self.fitAddon = new FitAddon(self.session.dataPlane)
                term.loadAddon(self.fitAddon)

                // self.enableGPUAccelerate()
                self.utils.conf.GlobalConf.termEnableGPUAccelerate ? self.enableGPUAccelerate() : console.log("skip enableGPUAccelerate cause by self.utils.conf.GlobalConf:", self.utils.conf.GlobalConf)
                // console.log("loadWebfontAndOpen to resize")

                self.termFit()
                term.focus()

                // 订阅标签切换到当前终端的信息
                self.env.sub('focusTerm-' + self.tabID, self.focusTermHandler)
                self.env.sub('blurTerm-' + self.tabID, self.blurTermHandler)
                self.env.sub('resize-' + self.tabID, self.resizeHandler)
                self.env.sub('export-log-' + self.tabID, self.exportLogHandler)
                self.env.sub('print-log-' + self.tabID, self.printLogHandler)
                self.env.sub('show-term-search-' + self.tabID, self.openSearch)
                self.env.sub('show-term-vim-mode-' + self.tabID, self.openVimMode)
                

                // GPU 加速时, 实例超过一定数量(chrome/win 10 上是 16)后, 最早打开的实例会由于渲染器不够导致无法渲染
                // 所以每次切换到终端的时候都要重新启用 GPU 加速以使用新的实例来渲染
                self.env.tab.currentChangeAddCallback((arg) => {
                    if (arg.to.key === self.tabID) {
                        // console.log(`terminal ${arg.to.key} handler for enable GPU accelerate`)
                        self.utils.conf.GlobalConf.termEnableGPUAccelerate ? self.enableGPUAccelerate() : console.log("skip enableGPUAccelerate cause by self.utils.conf.GlobalConf:", self.utils.conf.GlobalConf)
                    }
                })

                // search addon example
                // searchAddon.findNext('#')
                term.search = searchAddon

                term.attachCustomKeyEventHandler(self.keyboardEvHandler)
                // term.onKey((ev) => { console.log("term onkey ev:", ev) })
            })

            self.term = term
        },
        termOnData(data) {
            if (this.session.dataPlane.readyState === this.session.dataPlane.OPEN) {
                this.session.dataPlane.send(data)
                return
            }

            if (!data || data.length < 1) {
                return
            }

            let char = data[0]
            switch (char) {
                case "\r":
                    this.close()
                    break;
                case "r":
                case "R":
                    this.reconnect()
                    break
                case "s":
                case "S":
                    console.log("save terminal output")
                    this.exportLogHandler()
                    break;
                default:
                    console.log("unprocess char:", char)
            }
        },
        // termOnResize(ev) {this.session.Resize(ev.cols, ev.rows)},
        termOnTitleChange(title) {
            this.termTitle = title
        },
        termOnSelectionChange() {this.termCopySelection()},

        termCopySelection() {
            if (this.utils.conf.GlobalConf.termAutoCopySelected === false) return

            let self = this
            let selection = this.term.getSelection()
            if (this.term.hasSelection()) {
                    // navigator.clipboard.writeText(selection)
                this.utils.copyToClipboard(selection).then(() => {
                    this.env.term.tipsUpdateSelectedBytes(self.tabID, `Copied ${selection.length} byte${selection.length > 1 ? "s" : ""}`)
                }).catch((err) => {
                    this.env.term.tipsUpdateSelectedBytes(self.tabID, `Copy failed ${err}`)
                })
            } else {
                this.env.term.tipsUpdateSelectedBytes(self.tabID, ``)
            }

            // 在 firefox 上选中内容之后终端会失去焦点, 这里重新 focus 一下
            this.term.focus()
        },
        termFit() {
            // console.log("termFit:", this.tabID)
            this.fitAddon.fit ? this.fitAddon.fit() : console.log("this.fitAddon.fit is not ready, skip fit")
        },
        resizeHandler() {
            let self = this
            // console.log("resizeHandler")
            this.$nextTick(() => {
                self.termFit()
            })
        },
        blurTermHandler() {
            this.term.blur()
            // console.log("blur term", this.tabID)
        },
        focusTermHandler() {
            let self = this
            setTimeout(() => {self.term.focus()}, 0)
        },
        close() {
            // 发送 destroy tab 信号, tab 会删除, tab 删除后会 destroy 当前 vue component
            // vue component 的 beforeDestroy 会调用 this.session.Close()
            this.env.tabDestroy(this.tabID)
        },
        reconnect() {
            this.session.Reconnect()
        },
        updateStatus(status) {
            // connecting/open/close/error/unread
            this.$emit("updateStatus", this.tabID, status)
        },
        exportLogHandler() {
            let output = xtermjsUtils.getOutput(this.term)
            let name = xtermjsUtils.getHostFromTitle(this.termTitle) + ".txt"
            this.utils.downloadBlob(name, output)
        },
        printLogHandler() {
            this.utils.printText(xtermjsUtils.getOutput(this.term))
        },
        tabCtxMenu() {
            this.$refs.tabCtxMenu.open()
        },
        pasteHandler() {
          navigator.clipboard.readText().then((data) => {
            this.term.paste(data)
            this.term.focus()
          })
        },
        fullscreenHandler() {
          this.$fullscreen.toggle(document.querySelector(`#${this.tabID}`), {
            teleport: this.teleport,
            callback: (isFullscreen) => {
              this.fullscreen = isFullscreen
            },
          })
        },
        openSearch() {
            this.$refs.search.show()
        },
        openVimMode() {
            this.vimModeData = xtermjsUtils.getOutput(this.term)
            this.$refs.vimMode.show()
        },
        searchHandler(searchCtrl) {
            let pattern = searchCtrl.pattern
            let direction = searchCtrl.direction
            let option = {
                regex: searchCtrl.isRegex,
                wholeWord: searchCtrl.isWholeWord,
                caseSensitive: searchCtrl.matchCase,
                // incremental: true,
            }
            let found = (direction === 'prev' ? this.term.search.findPrevious(pattern, option) : this.term.search.findNext(pattern, option))
            // 如果搜索结果没有匹配的内容会导致搜索框丢失焦点，这里重新 focus 回搜索框
            if (!found) {
                this.utils.dom.domFocusById(`term-search-modal-${this.tabID}-input`)
            }
        },
        showSessOptionHandler() {
            console.log("showSessOptionHandler")
        },
        clearHandler() {
            this.term.clear()
            this.term.focus()
        },
        enableGPUAccelerate() {
            if (this.env.supportWebGL2) {
                console.log("Support WebGL2, enable GPU accelerate")
                this.term.loadAddon(new WebglAddon())
            } else {
                console.log("Not support WebGL2, disable GPU accelerate")
            }
        },

        // keyboardEvHandler
        // 返回值为 true 则不拦截 xtermjs 的处理逻辑, 交给 xtermjs 处理按键事件
        // 返回值为 false 则表示拦截 xtremjs 的处理逻辑, 在这里触发 mousetrap 的事件
        keyboardEvHandler(ev) {
            // console.debug("terminal keyboardEvHandler ev:", ev)
            let meta = ev.metaKey
            let ctrl = ev.ctrlKey
            let alt = ev.altKey
            let shift = ev.shiftKey
            let key = ev.key
            let isKeydown = ev.type === "keydown" ? true : false
            let isKeyup = ev.type === "keyup" ? true : false

            // 确保在 terminal active 时可以通过 alt+F4 关闭窗口
            if (isKeydown && alt && key === "F4") {
                console.debug("down alt, key:", key)
                return false
            }

            if (key === 'Meta' || key === 'Control' || key === 'Alt' || key === 'Shift' || key === 'Meta' || key === 'Enter') {
                // console.debug("keyboardEvHandler skip ", key)
                return true
            }


            for (let group of this.utils.hotKey.GlobalHotKey.getGroupList()) {
                for (let hkey of group.getKeyList()) {
                    // console.log("process", hkey)
                    if (hkey.keyType === "keydown" && !isKeydown) continue
                    if (hkey.keyType === "keyup" && !isKeyup) continue
                    let combos = this.utils.hotKey.texts2keys(hkey.keys)
                    for (let combo of combos) {
                        let mstev = `${meta ? 'meta+' : ""}${ctrl ? 'ctrl+' : ""}${alt ? 'alt+' : ""}${shift ? 'shift+' : ""}${key}`
                        // console.log("compare:", mstev, " with ", combo)
                      if (mstev === combo) {
                            // console.log("trigger mstev:", mstev, " by ", combo)
                            if (typeof(hkey.cb) === "function") {
                                hkey.cb(mstev)
                                return false
                            }
                            return true
                        }
                    }
                }
            }

            if (this.env.running.isDarwin()) {
                let isSpecialAltChar = this.utils.hotKey.macAltMap.macAltText2Key.has(key)
                // console.log("isSpecialAltChar:", isSpecialAltChar)
                // 拦截 terminal 的这两个快捷键
                if ((alt && isSpecialAltChar && !ctrl && !shift) ||
                    (ctrl && key === "o" && !alt && !shift) ||
                    (ctrl && key === "Tab" && !alt) ||
                    (alt && key === "Tab" && !ctrl) ||
                    (alt && key === "˚" && !ctrl && !shift) ||
                    (alt && key === "˙" && !ctrl && !shift) ||
                    (ctrl && shift && key === "R" && !alt) ||
                    (ctrl && shift && ";6S")) {
                    return false
                }
            }
            return true
        },
    },
}
</script>
